'use client';

import { useAuthReady } from '@/context/AuthContext';
import { QueryClient, QueryClientProvider, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReactNode, useState } from 'react';

export default function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnMount: false,
          },
        },
      }),
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}

export function useAuthQuery<T>(options: UseQueryOptions<T>) {
  const { enabled } = useAuthReady();

  return useQuery({
    ...options,
    enabled: enabled && (options.enabled ?? true),
  });
}
